import { AfterViewInit, Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { Router, ActivatedRoute, Params, ParamMap } from '@angular/router';


import { ProductsService } from '../../shared/services/products.service';
import { AccountService } from '../../shared/services/account.service';
import { UtilsService } from '../../shared/services/utils.service';
import { AppService } from '../../shared/services/app.service';
import { ContactService } from '../../shared/services/contact.service';
import { LanguageService } from '../../shared/services/language.service';

import{ TheyTrusUsService } from '../../shared/services/theyTrusUs.service'

import { TranslateService } from '@ngx-translate/core';

import { ProdTagService } from '../../shared/services/prodtag.service';

import { Location } from '@angular/common';

declare var $: any; import {isBrowser} from '../../shared/thirdparty/isBrowser'

@Component({
    selector: 'app-products',
    templateUrl: './products.component.html',
    styleUrls: ['./products.component.css']
})
export class ProductsComponent implements OnInit, AfterViewInit {

    @Input() forJSPage = false

    public productsLoading = true
    public routeSub:any = null
    public products:any = []
    public totalProductsNb = 0
    public allCategories = []
    public categories:any = []
    public checkedTags:any = {}
    public searchString = ''
    public disableCheckbox = true
    public keyUpTimer = null
    public offset = 0
    public showMoreLoading = false
    public mobileFilters = false
    public tagsDeployed = {}
    public initialTagDeployed = null;


    //<-- NEW PRODUCTS BEHAVIOR - ADDED NOVEMBER 2021
    public pageDevicesOrNot = false
    public parametreUrl: string = null;
    public deviceName = null;
    public routeSub2:any = null;
    public checkPageLoaded = false;
    public tagsWithProducts = []
    //END NEW PRODUCTS BEHAVIOR - ADDED NOVEMBER 2021 -->

    jsPageForceCats = [14, 9]

    public headsets = [
        { name : 'HTC VIVE™ Focus 3', png : "assets/materiel/focus3-full.png", webp : "assets/materiel/focus3-face.webp" },
        { name : 'Meta Quest 2', png : "assets/materiel/metaquest2-face.png", webp : "assets/materiel/metaquest2-face.webp" },
        { name : 'Pico Neo 3 & 4', png : "assets/materiel/pico3-full.png", webp : "assets/materiel/pico-neo3-face.webp" }
    ]

    public contributors = []
    public logos = []
    public logosIntervals = null


    constructor(
        private productService: ProductsService,
        public accountService: AccountService,
        public utilsService: UtilsService,
        public appService: AppService,
        public prodTagService: ProdTagService,
        public translate : TranslateService,
        private activatedRoute: ActivatedRoute,
        public router: Router,
        public language : LanguageService,
        private route: ActivatedRoute,
        public location : Location,
        public theyTrusUsService: TheyTrusUsService
    ) {

    }

    ngOnInit(){
        this.routeSub = this.activatedRoute.queryParams.subscribe(params => {
            this.checkedTags = {}
            if(params['tags']){
                for(let tagId of ((params['tags']) ? params['tags'].replace(/[^0-9,]/g, "").split(',').map(e => parseInt(e)).filter(e => !isNaN(e)) : [] )){
                    this.checkedTags[tagId.toString()] = true
                }
            }
            if(params['search']){
                this.searchString = params['search']
            }
            this.refreshTags()
            .then(()=>{
                this.refreshProducts()
            })

        });

        if(isBrowser()){
          this.theyTrusUsService.getTrustCompanies(1)
          .then((companies)=>{
              this.logos = companies
              this.refreshLogos()
                //  this.logosIntervals = setInterval(()=>{
                //     this.refreshLogos()
                // },5000)
          })
        }

    }

    ngAfterViewInit() {
        if(!this.forJSPage && isBrowser()){
            $('video')[0]['muted'] = true;
            $('video')[0].load();
        }
    }


    //<-- NEW PRODUCTS BEHAVIOR - ADDED NOVEMBER 2021
    // We search the name of the Device by its ID retrieved in the queryParams from URL
    searchDeviceName(parametresUrl){
      if(parametresUrl!==null && parametresUrl!==undefined){
        // We retrieve the category whose id=1 ("Catalogs")
        const catalogsCategory = this.allCategories.find(x => x.id == 1);
        // We retrieve the name of the Device whose id is equal to the queryParams retrieved from URL
        for(let param of parametresUrl){
          if(catalogsCategory.tags.find(x => x.id == param)){
            const name = catalogsCategory.tags.find(x => x.id == param)?.name;
            this.deviceName = name;
          }
        }

      }
    }
    //END NEW PRODUCTS BEHAVIOR - ADDED NOVEMBER 2021 -->



    // searchCategory(parametresUrl){
    //   var array = [];
    //   for(let tag of parametresUrl){
    //     array.push(tag);
    //   }
    //   for(let category of this.allCategories){
    //     for(let tag of array){
    //       if(category.tags.find(x => x.id == tag)){
    //         this.tagsDeployed[category.id] = true;
    //       }
    //     }
    //   }
    // }



    refreshProducts(){
        // We make sure to delete the content of the search bar before each reload
        if(!this.router.url.includes('devices') && this.router.url.includes('device')){
          this.searchString = "";
        }
        //END NEW PRODUCTS BEHAVIOR - ADDED NOVEMBER 2021 -->
        this.productsLoading = true
        this.offset=0

        var tagIds = Object.keys(this.checkedTags).filter(e => this.checkedTags[e])
        if(this.forJSPage){
            tagIds.push("221")
        }

        this.productService.searchProducts(this.searchString,tagIds, this.offset, 28)
        .then((res)=>{
            this.tagsWithProducts = res['tagsWithContent']
            this.offset=28
            this.totalProductsNb = res['quantity']
            this.products = this.productService.setProductsInfos(res['datas'],null,null)
            this.productsLoading = false
            this.disableCheckbox = false
            this.filterTags()
        })
    }

    showMoreProducts(){
        this.showMoreLoading = true
        this.disableCheckbox = true
        var tagIds = Object.keys(this.checkedTags).filter(e => this.checkedTags[e])
        if(this.forJSPage){
            tagIds.push("221")
        }
        this.productService.searchProducts(this.searchString,tagIds, this.offset, 12)
        .then((res)=>{
            this.offset = this.offset+12
            for(let product of res['datas']){
                if(!this.products.filter(e => ((e['isGroup'] || false) == (product['isGroup'] || false)) && Number(e['id']) == Number(product['id'])).length){
                    this.products.push(this.productService.setProductsInfos([product],null,null)[0])
                }
            }
            if(res['tags']){
                this.categories = res['tags']
                this.allCategories = JSON.parse(JSON.stringify(res['tags']))
            }
            this.showMoreLoading = false
            this.disableCheckbox = false

        })

    }

    refreshTags(){
        if(!this.categories.length){
            return this.prodTagService.getAllProdTags()
            .then((res)=>{
                for(let c of res){
                    c.tags = c.tags.filter(e => e.id != 221)
                }
                this.allCategories = JSON.parse(JSON.stringify(res))
                this.categories = res;
                this.checkPageLoaded = true;

                if(this.forJSPage){
                    this.tagsDeployed["9"] = true
                }
                else{
                    this.tagsDeployed["3"] = true
                }

                return this.categories
            })
        }
        else{
            return Promise.resolve(this.categories)
        }



    }

    changeTags(){
        this.disableCheckbox = true;
        this.mobileFilters=false
        this.changeUrl()
    }

    changeUrl(){
        var queryParams = {}
        //<-- NEW PRODUCTS BEHAVIOR - ADDED NOVEMBER 2021
        // We only add the devices fragment if the URL includes devices or device (in other words, if we already are on a device catalog page)
        if(this.router.url.includes('devices') || this.router.url.includes('device')){
          //END NEW PRODUCTS BEHAVIOR - ADDED NOVEMBER 2021 -->
          if(this.searchString){ queryParams['search'] = this.searchString }
          if(Object.keys(this.checkedTags).filter(e => this.checkedTags[e]).length){ queryParams['tags'] = Object.keys(this.checkedTags).filter(e => this.checkedTags[e]).join(',') }
          this.router.navigate([],{
              relativeTo: this.activatedRoute,
              queryParams: queryParams,
              //<-- NEW PRODUCTS BEHAVIOR - ADDED NOVEMBER 2021
              // We add and keep a new fragment to the URL when it changes because the first one disappears when the user clicks on a filter tag
              fragment: "devices"
              //END NEW PRODUCTS BEHAVIOR - ADDED NOVEMBER 2021 -->
          });
        }
        else{
          if(this.searchString){ queryParams['search'] = this.searchString }
          if(Object.keys(this.checkedTags).filter(e => this.checkedTags[e]).length){ queryParams['tags'] = Object.keys(this.checkedTags).filter(e => this.checkedTags[e]).join(',') }
          this.router.navigate([],{
              relativeTo: this.activatedRoute,
              queryParams: queryParams
          });
        }

    }

    handleKeyUp(){
        if(this.keyUpTimer){
            if(isBrowser()) clearTimeout(this.keyUpTimer);
            this.keyUpTimer = null;
        }
        if(isBrowser()) this.keyUpTimer = setTimeout(() => {
            this.disableCheckbox = true;
            this.changeUrl()
            this.keyUpTimer = null;
        },300)
    }

    ngOnDestroy() {
        this.pageDevicesOrNot = false;
        this.routeSub.unsubscribe();
        if(isBrowser()){
            clearInterval(this.logosIntervals)
        }
    }

    toggleFilters(){
        if(isBrowser() && $('#searchAndFilters').css('display')=='block'){
            this.mobileFilters=false
        }
        else{
            this.mobileFilters=true
        }
    }

    filtersUsed(){
        return JSON.stringify(this.checkedTags) != '{}' || this.searchString
    }

    filterTags(){
        var definitiveCats = []
        this.categories = JSON.parse(JSON.stringify(this.allCategories))
        for(let cat of this.categories){
            var tmpCat = JSON.parse(JSON.stringify(cat))
            tmpCat['tags'] = []
            for(let tag of cat['tags']){
                tag['checked'] = Object.keys(this.checkedTags).filter(e => this.checkedTags[e]).includes(tag['id'].toString())
            }
            for(let tag of cat['tags']){
                if(!this.tagsWithProducts.includes(tag['id'])){
                    // tag['hideMethod'] = cat['tags'].filter(e => e['checked']).length ? 'red' : 'hide'
                    tag['hideMethod'] = 'hide'
                }
            }
            cat['tags'] = cat['tags'].filter(e => !e['hideMethod'] || e['hideMethod'] == 'red')
        }
        this.categories = this.categories.filter(e => e['tags'].length)
    }


    // refreshLogos(){
    //     if(isBrowser()){
    //       $('.contributor').css('opacity','0')
    //       setTimeout(()=>{
    //           this.contributors = []
    //           if(this.logos && this.logos.length){
    //               for (let index = 0; index < 7; index++) {
    //                   var logoInfos = this.getRandomLogo();
    //                   this.contributors.push({url: this.theyTrusUsService.getLogoUrl(logoInfos.url), name: logoInfos.name});
    //               }
    //
    //               setTimeout(()=>{
    //                 $('.contributor').css('opacity','1')
    //               }, 200);
    //           }
    //
    //       }, 200);
    //     }
    // }
    //
    // getRandomLogo(){
    //     var random = Math.floor(Math.random()*this.logos.length);
    //     var logo = [];
    //     // The logo.name value will be later assigned to the alt of the logo image
    //     if(this.logos[random]['name']){
    //       logo.push({url: this.logos[random]['logo_url'], name: this.logos[random]['name']});
    //     }
    //     else{
    //       logo.push({url: this.logos[random]['logo_url'], name: 'company'});
    //     }
    //     if (this.contributors.filter(e => e.url === this.theyTrusUsService.getLogoUrl(this.logos[random]['logo_url'])).length > 0) {
    //       return this.getRandomLogo()
    //     }
    //     else{
    //         return logo[0];
    //     }
    // }

    refreshLogos() {
      this.contributors = [];
      if (this.logos && this.logos.length) {
        // Shuffle the logos array to randomize the order
        const shuffledLogos = this.shuffleArray([...this.logos]);
        for (let index = 0; index < shuffledLogos.length; index++) {
          const logoInfo = shuffledLogos[index];
          const name = logoInfo.name ? logoInfo.name : 'company';
          const url = this.theyTrusUsService.getLogoUrl(logoInfo.logo_url);
          this.contributors.push({ url: url, name: name });
        }
      }
    }

    shuffleArray(array: any[]) {
      // Function to shuffle an array using Fisher-Yates algorithm
      for (let i = array.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [array[i], array[j]] = [array[j], array[i]];
      }
      return array;
    }

}
